import RecognitionOTPVerification from "./RecognitionOTPVerification";

export default RecognitionOTPVerification;
